import { QuizConfig } from '../types/quiz';
import lifeExpectancyQuiz from './quizzes/lifeExpectancy';
import dementiaRiskQuiz from './quizzes/dementiaRisk';
import stressIndexQuiz from './quizzes/stressIndex';
import sleepHealthQuiz from './quizzes/sleepHealth';
import mentalHealthQuiz from './quizzes/mentalHealth';

const quizRegistry: QuizConfig[] = [
  lifeExpectancyQuiz,
  dementiaRiskQuiz,
  stressIndexQuiz,
  sleepHealthQuiz,
  mentalHealthQuiz,
];

export function getQuizById(id: string): QuizConfig | undefined {
  return quizRegistry.find((q) => q.id === id);
}

export function getAllQuizzes(): QuizConfig[] {
  return quizRegistry;
}

export default quizRegistry;
